import React from 'react';
export function Highlight({ highlighted, content }) {
    return highlighted ? (React.createElement("span", { className: "WhSearch-Highlight", dangerouslySetInnerHTML: { __html: highlighted } })) : (React.createElement("span", { className: "WhSearch-Highlight" }, content));
}
//# sourceMappingURL=Highlight.js.map